import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { NoItemsLeftInTable, handleDateSetUp } from "../../../../../helper/helpers";
import Pagination from "../../../../commanPage/paginationUi/Pagination";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBidderPermissionDetails } from "../../../../../redux/action/bidPermission";
import TableLoader from "../../../../commanPage/loader/TableLoader";
import { Collapsible, CollapsibleItem } from 'react-materialize'



function BiddingPermission({ searchData }) {
  const totalNumberRow = 50;
  const { id } = useParams();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [bidPermissionData, setBidPermissionData] = useState([]);
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const { permissionBidder, permissionBidderLoading } = useSelector(
    (state) => state.bidderPermission
  );

  const [openRow, setOpenRow] = useState(null);

  const toggleRow = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  useEffect(() => {
    dispatch(getBidderPermissionDetails(id));
  }, [id, dispatch]);


  useEffect(() => {
    setBidPermissionData(permissionBidder)
  }, [permissionBidder])

  useEffect(() => {
    if (searchData) {
      const filteredData = permissionBidder?.filter((item) => {
        return (
          item?.trader?.organizationName
            ?.toLowerCase()
            .includes(searchData.toLowerCase()) ||
          item?.trader?.GSTIN?.toLowerCase().includes(searchData.toLowerCase()) ||
          item?.trader?.panCardNumber
            ?.toLowerCase()
            .includes(searchData.toLowerCase())
        );
      });
      setBidPermissionData(filteredData);
    } else {
      setBidPermissionData(permissionBidder);
    }
  }, [searchData, permissionBidder]);

  if (permissionBidderLoading) {
    return (
      <div className="valign-wrapper justify-center cover white mt-1">
        <TableLoader
          headerData={[
            "Organization",
            "GST",
            "Pan Card",
            "Paid lots",
            "PCB Account",
          ]}
        />
      </div>
    );
  }
  console.log('bidPermissionData', bidPermissionData)
  return (
    <div>
      <div className="table-container-style mt-1">

        <table
          className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
            }`}
        >
          <thead>
            <tr>
              <th>Organization</th>
              <th>GST</th>
              <th>Pan Card</th>
              <th>Paid lots</th>
              <th>PCB Account</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {bidPermissionData
              ?.slice(currentPage, currentPage + totalNumberRow)
              ?.map((item, index) => (
                <React.Fragment key={index}>
                  {/* MAIN ROW (Collapsible Header) */}
                  <tr
                    className="collapsible-trigger"
                    style={{ cursor: "pointer", backgroundColor: openRow == index ? "#c7a8e2c2" : "" }}
                    onClick={() => toggleRow(index)}
                  >
                    <td>{item?.trader?.organizationName}</td>
                    <td>{item?.trader?.GSTIN}</td>
                    <td>{item?.trader?.panCardNumber || "..."}</td>
                    <td>{item?.offers?.length}</td>
                    <td>{item?.trader?.PCBVerified ? "Yes" : "No"}</td>
                    <td>
                      <span
                        style={{
                          color:
                            item?.status === "Active"
                              ? "green"
                              : item?.status === "Inactive"
                                ? "red"
                                : "orange",
                        }}
                      >
                        {item?.status}
                      </span>
                    </td>
                    <td>
                      {openRow == index ? <span class="material-symbols-outlined">
                        keyboard_arrow_up
                      </span> : <span class="material-symbols-outlined">
                        keyboard_arrow_down
                      </span>}
                    </td>
                  </tr>

                  {/* COLLAPSIBLE ROW (Full Width Row) */}
                  {openRow === index && (
                    <tr style={{
                      backgroundColor: "#c7a8e2c2"
                    }} >
                      <td colSpan={6} style={{ padding: 0, border: "none" }}>

                        <Collapsible accordion
                          popout>
                          <CollapsibleItem
                            expanded={true}

                          >
                            <div className="flex align-start column" >
                              <table
                                className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
                                  }`}
                              >
                                <thead>
                                  <tr>
                                    <th>Lot Number</th>
                                    <th>EMD Amount</th>
                                    <th>Permission Type</th>
                                    <th>Scraps Details</th>
                                    <th>EMD Status</th>

                                    <th>Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.offers.map((singleOffer, offerIndex) => (
                                    <tr key={offerIndex} >
                                      <td>
                                        {singleOffer.offerNumber}
                                      </td>
                                      <td>
                                        {singleOffer.EMDAmount} INR
                                      </td>

                                      <td>
                                        {singleOffer.permissionType}
                                      </td>

                                      <td>
                                        {singleOffer.scrapDetails?.type}-{singleOffer.scrapDetails?.quantity} {singleOffer.scrapDetails?.unit}
                                      </td>
                                      <td>{singleOffer.emdStatus || '---'}</td>
                                      <td>
                                        {handleDateSetUp(singleOffer.permissionDate)}
                                      </td>
                                    </tr>
                                  ))
                                  }
                                </tbody>

                              </table>
                            </div>
                          </CollapsibleItem>
                        </Collapsible>

                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
          </tbody>
        </table>

        {bidPermissionData?.length === 0 && <NoItemsLeftInTable />}
      </div>
      <Pagination
        Data={bidPermissionData}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}

export default BiddingPermission;
